import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const Footer = () => {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      setupMarquee();
    });
    
    const setupMarquee = () => {
      if (!textRef.current || !containerRef.current) return;
      
      // 停止所有現有動畫
      gsap.killTweensOf(textRef.current);
      
      // 確保文字初始化在可測量的位置
      gsap.set(textRef.current, { x: 0, visibility: 'hidden' });
      
      setTimeout(() => {
        // 獲取文字和容器的真實寬度
        const textElement = textRef.current;
        const containerElement = containerRef.current;
        
        // 考慮到 padding 的真實寬度 (CSS中是padding: 0 20px)
        const computedStyle = window.getComputedStyle(textElement);
        const textPadding = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        
        // 獲取文字內容的真實寬度
        const textContentWidth = textElement.scrollWidth;
        const totalTextWidth = textContentWidth + textPadding;
        const containerWidth = containerElement.offsetWidth;
        
        console.log('Text width:', totalTextWidth, 'Container width:', containerWidth);
        
        // 動態設置參數，特別關注行動裝置
        const isMobile = containerWidth < 768;
        
        // 關鍵修改：確保行動裝置有足夠的結束距離
        // 1. 起始位置：確保從視窗外開始
        // 2. 結束位置：確保完全離開視窗左側
        const startPosition = containerWidth;
        
        // 使用更安全的結束位置計算，確保完全滾出
        // 增加額外安全邊距，特別是對行動裝置
        const safetyMargin = isMobile ? 150 : 20;
        const endPosition = -(totalTextWidth + safetyMargin);
        
        // 運動距離計算
        const totalDistance = startPosition - endPosition;
        
        // 針對裝置類型調整速度，但確保行動裝置有足夠時間完成循環
        const baseDuration = isMobile ? 10 : 7; // 行動裝置較慢
        const duration = totalDistance / (isMobile ? 40 : 80);
        
        // 重新顯示文字並設置起始位置
        gsap.set(textRef.current, { x: startPosition, visibility: 'visible' });
        
        // 重新設計動畫邏輯
        const animateMarquee = () => {
          gsap.to(textRef.current, {
            x: endPosition,
            duration: duration,
            ease: "none",
            onComplete: () => {
              // 動畫完成後確保文字完全不可見，再重置位置
              gsap.set(textRef.current, { x: startPosition });
              // 適當的循環延遲，行動裝置稍長
              const delay = isMobile ? 1.0 : 0.3;
              gsap.delayedCall(delay, animateMarquee);
            }
          });
        };
        
        // 開始第一個循環
        animateMarquee();
      }, 100); // 稍微增加延遲確保測量準確
    };
    
    // 初始設置
    setupMarquee();
    
    // 監聽大小變化
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    
    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
      gsap.killTweensOf(textRef.current);
    };
  }, []);
  
  return (
    <footer className="site-footer">
      <div className="marquee-container" ref={containerRef}>
        <div className="marquee-text" ref={textRef}>
          《都是謊言惹的禍》愛情喜劇，2025/4/19於臺中市大墩文化中心舉行首映會！座位有限，要搶要快！   |    可愛月老杯套限量販售中！詳情請持續關注社群帳號    |
        </div>
      </div>
    </footer>
  );
};

export default Footer;